import { SessionExpireeError, getApi } from '@/lib/api';
import { lireSession } from '@/lib/session';
import type { AnalyseTexte } from '@rosetta/shared';
import { useQuery } from '@tanstack/react-query';

/** The query key of the analysis of a translation (its purpose and its invariants, #9). */
export const cleAnalyse = (id: string) => ['analyse', id] as const;

/**
 * Reads what Tahiti says about the text of a translation (its purpose and its invariants),
 * once the translation is finished (`actif`). It is an addition to the page, never a
 * condition of it: no automatic retry, and a failed read leaves the page as it is (the
 * caller shows nothing for `data` undefined). A finished translation does not change, so what
 * was read stays fresh for the whole session.
 */
export function useLectureAnalyse(id: string, actif: boolean) {
  return useQuery<AnalyseTexte, Error>({
    queryKey: cleAnalyse(id),
    queryFn: () => {
      const session = lireSession();
      if (session === null) throw new SessionExpireeError();
      return getApi().lireAnalyse(session, id);
    },
    enabled: actif,
    retry: false,
    staleTime: Number.POSITIVE_INFINITY,
  });
}
